var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "checkboxes"
  }, _vm._l(_vm.normalized, function (o) {
    return _c('CheckboxItem', {
      key: o.value,
      attrs: {
        "id": "cb-".concat(o.value),
        "label": o.label,
        "value": o.value,
        "right-display-info": o.rightDisplayInfo,
        "detailed-info": o.detailedInfo,
        "expandable": o.expandable,
        "checked": _vm.selectedSet.has(o.value)
      },
      on: {
        "toggle": _vm.toggle
      },
      scopedSlots: _vm._u([{
        key: "details",
        fn: function fn(slotProps) {
          return [_vm._t("details", null, null, slotProps)];
        }
      }], null, true)
    });
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }